import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sidebar-base',
  standalone: true,
  imports: [],
  templateUrl: './sidebar-base.component.html',
  styleUrl: './sidebar-base.component.scss'
})
export class SidebarBaseComponent {
  @Input() showSidebarHeader: boolean = true;
}
